/**
 * GTM for contact form
 *
 * @example
 * initWPCF7Gtm();
 *
 * @returns {void}
 */
const initWPCF7Gtm = () => {

    let event_checkout = false;

    if(typeof product !== 'undefined') {

        //Данные необходимо отправлять в момент, когда пользователь кликает на кнопку вызова формы на карточке товара
        $('.p-product .js-callback, .p-product .js-pre-order, .p-product .js-constructor-pre-order').on('click', function () {
            let form_id = $(this).data('form-id');

            console.log('event: addToCart - ' + form_id);

            dataLayer.push({
                'event': 'addToCart',
                'form_name': form_id, //где вместо XXXXXX передаем название формы
                'ecommerce': {
                    'currencyCode': 'UAH',
                    'add': {
                        'products': [{
                            'name': product.name, // Название товара. ВАЖНО! Название товара при просмотре информации о товаре, а также других действиях описанных ниже должны быть идентичными.
                            'id': product.id, // передаем код товара
                            'price': product.price, // передаем цену товара от. Важно! Передаем только цифры
                            'category': product.category, // передаем категорию товара
                            'variant': product.variant, // Передаем артикул товара
                            'quantity': product.quantity
                        }]
                    }
                }
            });
        });

        //Передаем в момент, когда в какой-то из форм на карточке товара происходит событие change.
        $('.wpcf7-form-control').on('change', function () {
            let form_id = $(this).parents('.wpcf7').find('[type="hidden"][name="_wpcf7"]').val();

            if(event_checkout != form_id) {
                console.log('event: checkout - ' + form_id);

                dataLayer.push({
                    'event': 'checkout',
                    'form_name': form_id, //где вместо XXXXXX передаем название формы
                    'ecommerce': {
                        'checkout': {
                            'actionField': {'step': 1},
                            'products': [{      // Массив товаров который описывает какие товары были добавлены в корзину
                                'name': product.name,         // Название товара. ВАЖНО! Название товара при просмотре информации о товаре, а также других действиях описанных ниже должны быть идентичными.
                                'id': product.id, // передаем код товара
                                'price': product.price, // передаем цену товара от. Важно! Передаем только цифры
                                'category': product.category, // передаем категорию товара
                                'variant': product.variant, // Передаем артикул товара
                                'quantity': product.quantity
                            }]
                        }
                    }
                });

                event_checkout = form_id;
            }
        });
    }

    document.addEventListener('wpcf7mailsent', (event) => {
        let form_id = event.detail.contactFormId;

        //Отправляем данные при всплывании окна благодарности на карточке товара
        if(typeof product !== 'undefined') {
            console.log('event: send_form_purchase - ' + form_id);

            dataLayer.push({
                'event': 'send_form',
                'form_name': form_id, //где вместо XXXXXX передаем название формы
                'ecommerce': {
                    'currencyCode': 'UAH',
                    'purchase': {
                        'actionField': {
                            'id': 'T:'+new Date().getTime()+'.'+Math.floor(10000 + Math.random() * (99999 - 10000)),                         	// ID Транзакции
                            'affiliation': 'blanche.ua - form: '+form_id, //где вместо XXXXXX передаем название формы
                            'revenue': product.price                     // Стоимость транзакции
                        },
                        'products': [
                            {          		 // Массив товаров который описывает какие товары купили
                                'name': product.name,         // Название товара. ВАЖНО! Название товара при просмотре информации о товаре, а также других действиях описанных ниже должны быть идентичными.
                                'id': product.id, // передаем код товара
                                'price': product.price, // передаем цену товара от. Важно! Передаем только цифры
                                'category': product.category, // передаем категорию товара
                                'variant': product.variant, // Передаем артикул товара
                                'quantity': product.quantity
                            }
                        ]
                    }
                }
            });
        }
        else {
            console.log('event: send_form - ' + form_id);

            //При успешной отправке форм на сайте передаем следующие данные
            dataLayer.push ({
                'event': 'send_form',
                'form_name': form_id  // где вместо XXXXXX передаем название формы
            })
        }
    }, false);
};

initWPCF7Gtm();
